import React, { useEffect, useMemo, useState } from 'react'
import { Alert, Button, Container, Form, ListGroup } from 'react-bootstrap'
import DesktopTable from './DesktopTable'
import MobileTable from './MobileTable'
import {
	deleteWorker,
	getWorkerCategories,
	getWorkerEmploymentTypes,
	getWorkerMathSalary,
	getWorkerMathTime,
	getWorkerQualificationTypes,
	getWorkers,
	getWorkersRemove,
	getWorkerTypes,
	updateWorker
} from './WorkersAPI'
import Create from './CreateWorker'
import { FaTrash } from 'react-icons/fa';
import { FaRegEdit } from "react-icons/fa";
import CreateWorkerCategory from './CreateWorkerCategory';
import EditWorkerCategory from './EditWorkerCategory';

const Workers = ({ jwt }) => {
	const mobileSize = 1200
	const [workers, setWorkers] = useState([]);
	const [allWorkers, setAllWorkers] = useState([]);

	const [removeWorkers, setRemoveWorkers] = useState([]);

	const [workerCategories, setWorkerCategories] = useState([])
	const [workerTypes, setWorkerTypes] = useState([])
	const [workerMathSalary, setWorkerMathSalary] = useState([])
	const [workerEmploymentTypes, setWorkerEmploymentTypes] = useState([])
	const [workerMathTime, setWorkerMathTime] = useState([])
	const [workerQualification, setWorkerQualification] = useState([]);
	const [isMobile, setIsMobile] = useState(window.screen.width - mobileSize <= 0);
	const [isCreateWorker, setIsCreateWorker] = useState(false);

	const [textSearch, setTextSearch] = useState('');
	const [isCreatingCategory, setIsCreatingCategory] = useState(false);
	const [isEditingCategory, setIsEditingCategory] = useState(-1);

	useEffect(() => {
		setWorkers(allWorkers.filter(o => (o.name + ' ' + o.firstName + ' ' + o.secondName + ' ' + o.thirdName).toLowerCase().includes(textSearch.toLowerCase())));
	}, [textSearch]);

	useEffect(() => {
		async function didMount() {
			const responseWorkers = await getWorkers(jwt);
			setWorkers(responseWorkers ?? []);
			setAllWorkers(responseWorkers ?? []);
			setWorkerCategories((await getWorkerCategories(jwt)) ?? [])
			setWorkerTypes((await getWorkerTypes(jwt)) ?? [])
			setWorkerMathSalary((await getWorkerMathSalary(jwt)) ?? [])
			setWorkerEmploymentTypes((await getWorkerEmploymentTypes(jwt)) ?? []);
			setWorkerMathTime((await getWorkerMathTime(jwt)) ?? [])
			setWorkerQualification((await getWorkerQualificationTypes(jwt)) ?? []);

			setRemoveWorkers((await getWorkersRemove(jwt)) ?? []);
		}
		didMount()

		setIsMobile(document.body.clientWidth - mobileSize <= 0);
		window.addEventListener('resize', function (event) {
			setIsMobile(document.body.clientWidth - mobileSize <= 0);
		})
	}, [])

	const handleWorkerDelete = id => {
		setAllWorkers(allWorkers.filter(worker => worker.id !== id))
		setWorkers(workers.filter(worker => worker.id !== id))
	}

	const WorkerView = ({ worker, isDeleted }) => {

		return isMobile ? <MobileTable
			isDeleted={isDeleted}
			deleteWorker={deleteWorker}
			employmentTypes={workerEmploymentTypes}
			handleDelete={handleWorkerDelete}
			jwt={jwt}
			mathSalaryTypes={workerMathSalary}
			mathTimeTypes={workerMathTime}
			qualificationTypes={workerQualification}
			updateWorker={updateWorker}
			worker={worker}
			workerCategories={workerCategories}
			workerTypes={workerTypes}
		/> :

			<DesktopTable
				isDeleted={isDeleted}
				deleteWorker={deleteWorker}
				employmentTypes={workerEmploymentTypes}
				handleDelete={handleWorkerDelete}
				jwt={jwt}
				mathSalaryTypes={workerMathSalary}
				mathTimeTypes={workerMathTime}
				qualificationTypes={workerQualification}
				updateWorker={updateWorker}
				worker={worker}
				workerCategories={workerCategories}
				workerTypes={workerTypes}
			/>
	}

	const CategoryView = ({ category, workers }) => {

		if (!workers || workers.length == 0)
			return '';

		return <div className='mt-3'>
			<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
				<h3>{category.name}</h3>
				<FaRegEdit
					onClick={() =>
						setIsEditingCategory(category.id)
					}
					style={{
						marginLeft: 10,
						transform: "scale(1.5)",
						cursor: "pointer"
					}}
				/>
			</div>
			<ListGroup>
				{
					workers.map(worker => <WorkerView key={worker.id} worker={worker} />)
				}
			</ListGroup>
		</div>
	}

	return <React.Fragment>
		<Container style={{
			maxWidth: '1440px',
			margin: '40px auto',
		}}>
			<h1 style={{ textAlign: 'center' }}>Сотрудники цеха</h1>
			<Button onClick={() => setIsCreateWorker(true)} variant='success'>Создать</Button>
			<Button variant="primary" onClick={() => setIsCreatingCategory(true)}>
				Создать категорию
			</Button>
			<Form.Control
				className='mb-3 mt-3'
				type='text'
				value={textSearch}
				onChange={(e) => setTextSearch(e.target.value)}
			/>
			{
				workerCategories.map(map => <CategoryView key={map.id} category={map} workers={workers.filter(f => f.categoryId == map.id)} />)
			}
			{
				(() => {
					const uncategorized = workers.filter(f => !workerCategories.some(c => c.id == f.categoryId));
					return uncategorized.length > 0 ? (
						<div className='mt-3'>
							<h3>Без категории</h3>
							<ListGroup>
								{uncategorized.map(worker => <WorkerView key={worker.id} worker={worker} />)}
							</ListGroup>
						</div>
					) : '';
				})()
			}
			<div className='mt-3' style={{ borderTop: '1px dashed red', paddingTop: 8 }}>
				<h3 style={{ display: 'flex', alignItems: 'center' }}>
					<FaTrash color='red' />
					<span>Удалены</span>
				</h3>
				{
					removeWorkers.length > 0 ?
						removeWorkers.map(map => <WorkerView key={map.id} worker={map} isDeleted={true} />)
						: <Alert variant='success'>Пусто</Alert>
				}
			</div>
		</Container>
		{
			isCreateWorker ?
				<Create show={isCreateWorker}
					employmentTypes={workerEmploymentTypes}
					mathSalaryTypes={workerMathSalary}
					mathTimeTypes={workerMathTime}
					onHide={() => setIsCreateWorker(false)}
					qualificationTypes={workerQualification}
					workerCategories={workerCategories}
					workerTypes={workerTypes}
					onCreated={() => window.location.reload()}
					jwt={jwt}
				/> : ''
		}
		{isCreatingCategory ? (
			<CreateWorkerCategory
				show={isCreatingCategory}
				onHide={() => setIsCreatingCategory(false)}
				jwt={jwt}
				onCreated={(e) => setWorkerCategories([...workerCategories, e])}
			/>
		) : isEditingCategory != -1 ? (
			<EditWorkerCategory
				id={isEditingCategory}
				show={isEditingCategory}
				onHide={() => setIsEditingCategory(-1)}
				jwt={jwt}
				onUpdate={(u) => {
					const temp = [...workerCategories];
					const index = temp.findIndex((f) => f.id == u.id);
					temp[index] = u;
					setWorkerCategories(temp);
				}}
				category={workerCategories.find((f) => f.id == isEditingCategory)}
			/>
		) : (
			""
		)}
	</React.Fragment>
}

export default Workers
